import { Injectable } from '@angular/core';
import { Yii } from 'libraries/interfaces/Yii';


@Injectable()
export class BookingStatusService {

    public statusesLabels: { [key: string]: string } = {
        [BookingXStatus.Cancel]: Yii.t('wui-shared-js', "Annulé"),
        [BookingXStatus.Confirm]: Yii.t('wui-shared-js', "Confirmé"),
        [BookingXStatus.Information]: Yii.t('wui-shared-js', 'Information'),
        [BookingXStatus.Quote]: Yii.t('wui-shared-js', 'Cotation'),
        [BookingXStatus.Request]: Yii.t('wui-shared-js', 'En demande'),
        [BookingXStatus.ActionRequired]: Yii.t('wui-shared-js', 'Action requise'),
        [BookingXStatus.Unknown]: Yii.t('wui-shared-js', "Inconnu"),
        [BookingXStatus.unableToConfirm]: Yii.t('wui-shared-js', "Confirmation impossible"),
        [BookingXStatus.OK]: Yii.t('wui-shared-js', "OK"),
        [BookingXStatus.Danger]: Yii.t('wui-shared-js', "Danger"),
    };

    public getStatusLabel(status: string): string {
        if (!status || !this.statusesLabels[status]) {
            return this.statusesLabels[BookingXStatus.Unknown];
        }

        return this.statusesLabels[status];
    }

}
export enum BookingXStatus {
    Information = 'information',
    Confirm = 'confirm',
    Quote = 'quote',
    Cancel = 'cancel',
    Request = 'request',
    ActionRequired = 'actionRequired',
    Unknown = 'unknown',
    unableToConfirm = 'unableToConfirm',
    OK = 'OK',
    Danger = 'Danger',
}
